import { render } from "./p-feature-flag.vue?vue&type=template&id=6b87a7a0"
import script from "./p-feature-flag.vue?vue&type=script&lang=js"
export * from "./p-feature-flag.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/p-feature-flag.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b87a7a0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b87a7a0', __exports__)) {
    api.reload('6b87a7a0', __exports__)
  }
  
  module.hot.accept("./p-feature-flag.vue?vue&type=template&id=6b87a7a0", () => {
    api.rerender('6b87a7a0', render)
  })

}


export default __exports__